import { InteractsWithDOM } from '@scripts/core/InteractsWithDOM.js';
import { InfoBlock } from '@scripts/carousel/classes/InfoBlock.js';

export default class InfosCarousel extends InteractsWithDOM {
    /**
     * Time in milliseconds between auto-change
     *
     * @type {number}
     */
    AUTOPLAY_INTERVAL = 3000;

    ACTIVE_AUTOPLAY = false;

    /**
     * Save if the mouse has hovered
     *
     * @type {boolean}
     */
    _mouseOver = false;

    /**
     * @type {InfoBlock[]}
     * @private
     */
    _infoBlocks;

    /**
     * @type {InfoBlock}
     * @private
     */
    _activeInfoBlock;

    get infoBlocks () {
        return this._infoBlocks;
    }

    set infoBlocks (value) {
        this._infoBlocks = value;
    }

    get activeInfoBlock () {
        return this._activeInfoBlock;
    }

    /**
     * @param value {InfoBlock}
     */
    set activeInfoBlock (value) {
        // Handle class change
        if (this._activeInfoBlock) {
            this._activeInfoBlock.hide();
        }

        value.display();

        // Handle value change
        this._activeInfoBlock = value;
    }

    constructor (domElm) {
        super(domElm);

        this.retrieveElements();
        this.addListeners();

        if (this.ACTIVE_AUTOPLAY)
            this.addAutoscroll();
    }

    addAutoscroll () {
        this.startAutoplay();
    }

    startAutoplay () {
        this.autoplayTimer = setInterval(() => {
            if (this.domElm.matches(':hover')) return;
            this.next();
        }, this.AUTOPLAY_INTERVAL);
    }

    resetAutoplay () {
        // Si un intervalle existe, on l'efface
        if (this.autoplayTimer) {
            clearInterval(this.autoplayTimer);
        }

        // Démarrer un nouvel intervalle
        if (this.ACTIVE_AUTOPLAY)
            this.startAutoplay();
    }

    retrieveElements () {
        this.infoBlocks = Array.from(this.domElm.querySelectorAll('.informations__tabs .tab'))
            .map(elm => new InfoBlock(this.retrieveId(elm)));

        this.activeInfoBlock = this.infoBlocks.filter(info => info.isDisplayed)[0];
    }

    addListeners () {
        this.infoBlocks.forEach((block) => {
            // Desktop
            block.tab.addEventListener('mouseenter', this.handleTabClick(block));

            // Mobile
            block.tab.addEventListener('touchstart', this.handleTabClick(block));
        });
    }

    handleTabClick (block) {
        return () => {
            this.resetAutoplay();

            if (this.activeInfoBlock !== block)
                this.activeInfoBlock = block;
        };
    }

    next () {
        const newIndex = (this.infoBlocks.findIndex(info => info._id === this.activeInfoBlock._id) + 1) % this.infoBlocks.length;
        this.activeInfoBlock = this.infoBlocks[newIndex];
    }

    /**
     * @param component
     * @return {string|null}
     */
    retrieveId (component) {
        return component?.id?.split('-').slice(1).join('-') ?? null;
    }
}
